import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '@/views/LandingPage.vue';
import AffiliatesPage from '@/views/AffiliatesPage.vue';
import ContactPage from '@/views/ContactPage.vue';
import FreeTrialPage from '@/views/FreeTrialPage.vue';
import LocationsPage from '@/views/LocationsPage.vue';
import SchedulePage from '@/views/SchedulePage.vue';
import TeamPage from '@/views/TeamPage.vue';
import LocationsIrvine from '@/views/LocationsIrvine.vue';
import LocationsBuenaPark from '@/views/LocationsBuenaPark.vue';
import ProgramsPage from '@/views/ProgramsPage.vue';
import RegisterIrvine from '@/views/RegisterIrvine.vue';

// Program pages - updated paths to components directory
import MuayThaiPage from '@/components/Programs/MuayThaiPage.vue';
import KidsFitnessPage from '@/components/Programs/KidsFitnessPage.vue';
import WomensFitnessPage from '@/components/Programs/WomensFitnessPage.vue';
import JiujitsuPage from '@/components/Programs/JiujitsuPage.vue';
import WrestlingPage from '@/components/Programs/WrestlingPage.vue';
import StrengthPage from '@/components/Programs/StrengthPage.vue';

const routes = [
  { path: '/', component: LandingPage },
  { path: '/affiliates', component: AffiliatesPage },
  { path: '/contact', component: ContactPage },
  { path: '/free-trial', component: FreeTrialPage },
  { path: '/locations', component: LocationsPage },
  { path: '/buena-park', component: LocationsBuenaPark },
  { path: '/irvine', component: LocationsIrvine },
  { path: '/programs', component: ProgramsPage },
  { path: '/irvine/register', component: RegisterIrvine },
  { path: '/schedule', component: SchedulePage },
  { path: '/team', component: TeamPage },
  // Program specific routes
  { path: '/programs/jiujitsu', component: JiujitsuPage },
  { path: '/programs/wrestling', component: WrestlingPage },
  { path: '/programs/womens-fitness', component: WomensFitnessPage },
  { path: '/programs/muay-thai', component: MuayThaiPage },
  { path: '/programs/kids', component: KidsFitnessPage },
  { path: '/programs/strength', component: StrengthPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 24,
      }
    }
    return { top: 0 }
  }
});

router.afterEach(() => {
  window.va?.track?.();
});

export default router;
